import React from "react";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {ButtonSize, ButtonVariant, Styled} from "./ActionButton.styles";

type ActionButtonProps = {
    label?: React.ReactNode
    variant?: ButtonVariant
    size?: ButtonSize
    icon?: IconProp
    iconRight?: IconProp
    fullWidth?: boolean
    disabled?: boolean
    type?: 'button' | 'submit'
    title?: string
    className?: string
    style?: React.CSSProperties
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
    children?: React.ReactNode
}

/**
 * The single call-to-action element of the site — four visual weights,
 * three sizes, optional leading / trailing icon.
 */
const ActionButton = (
    {
        label,
        variant = 'primary',
        size = 'md',
        icon,
        iconRight,
        fullWidth = false,
        disabled = false,
        type = 'button',
        title,
        className,
        style,
        onClick,
        children
    }: ActionButtonProps) => (
    <Styled.Button
        type={type}
        title={title}
        className={className}
        style={style}
        disabled={disabled}
        onClick={onClick}
        $variant={variant}
        $size={size}
        $fullWidth={fullWidth}
    >
        {icon && (<Styled.Icon icon={icon}/>)}
        {label ?? children}
        {iconRight && (<Styled.Icon icon={iconRight}/>)}
    </Styled.Button>
)

export default ActionButton
